export const RESET_ACTIVITIES = 'RESET_ACTIVITIES'
export const SET_ACTIVITIES = 'SET_ACTIVITIES'
